
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"1","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill-current",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1 1H0V0h1v1zm4 0H3V0h2v1zm4 0H7V0h2v1zm4 0h-2V0h2v1zm4 0h-2V0h2v1zm4 0h-2V0h2v1zm3 0h-1V0h1v1z","fill":"#444040"}})])
          )
        }
      }
    